











































import { Component, Inject, Vue } from 'vue-property-decorator'
import { FarmingViewModel } from '@/modules/sb-farm/viewmodels/farming-viewmodel'
import { Observer } from 'mobx-vue'
import { LockPeriods, Zero } from '@/constants'
import { FixedNumber } from '@ethersproject/bignumber'

@Observer
@Component
export default class extends Vue {
  @Inject() vm!: FarmingViewModel
  lockPeriods = LockPeriods

  getEstimateAPY(multiplier) {
    try {
      return this.vm.annualPercentageRate.mulUnsafe(FixedNumber.from(`${multiplier}`))
    } catch (error) {
      return Zero
    }
  }
}
